'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnchorStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  alignItems: _propTypes2.default.oneOf(['top', 'center', 'bottom'])
};

var defaultProps = {
  alignItems: 'center'
};

var ALIGN_MAP = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};

var align = function align(_ref) {
  var alignItems = _ref.alignItems;
  return 'align-items: ' + ALIGN_MAP[alignItems] + ';';
};

var colorScheme = function colorScheme(_ref2) {
  var active = _ref2.active,
      colorScheme = _ref2.colorScheme,
      themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var stateKey = active ? 'active' : 'default';
  var path = theme.reactackle.components.breadcrumbs.item.colorScheme[colorScheme][stateKey];

  var opacity = path.opacity,
      color = path.color;


  var hoverOpacity = path.hover.opacity || opacity;
  var hoverColor = path.hover.color || color;

  return (0, _styledComponents.css)(['opacity:', ';color:', ';&:hover{opacity:', ';color:', ';}&:focus{opacity:', ';color:', ';}'], opacity, color, hoverOpacity, hoverColor, path.focus.opacity || hoverOpacity, path.focus.color || hoverColor);
};

var active = function active(_ref3) {
  var active = _ref3.active;
  return active ? '\n    &,\n    &:hover,\n    &:focus {\n      cursor: default;\n    }\n  ' : '\n    &,\n    &:hover,\n    &:focus {\n      cursor: pointer;\n    }\n  ';
};

var AnchorStyled = exports.AnchorStyled = _styledComponents2.default.a.withConfig({
  displayName: 'AnchorStyled'
})(['text-decoration:none;display:flex;', ' ', ' ', ''], colorScheme, active, align);

AnchorStyled.propTypes = propTypes;
AnchorStyled.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-breadcrumbs/dist/BreadcrumbsItem/styles/AnchorStyled.js
// module id = 545
// module chunks = 0